module.exports = __webpack_public_path__ + "img/vodafone-es.305034ff.png";